import React from "react";

export default function RequiredText() {
  return (
    <span className="required-text">
      <span className="visually-hidden">Required</span>
    </span>
  );
}
